import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
var ScrollToTop = function (_a) {
    var wrapper = _a.wrapper;
    var pathname = useLocation().pathname;
    useEffect(function () {
        if (wrapper && wrapper.current && window.matchMedia('(min-width: 1024px)').matches) {
            wrapper.current.scrollTo(0, 0);
        }
        else {
            window.scrollTo(0, 0);
        }
    }, [pathname, wrapper]);
    return null;
};
export default ScrollToTop;
